import styled from 'styled-components';

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-right: 2%;
`;

export default ButtonGroup;
